export default __webpack_public_path__ + "static/media/Inter-LightItalic.8942ebe8.woff2";